<div class="applicant-details" *ngIf="form">
  <form #formContainer (ngSubmit)="onSubmit()" [formGroup]="form" lxFormErrorTracker [currentStep]="currentStep$ | async">
    <div class="applicant-details__guardian-full-name" *ngIf="juniorFlow">
      <lx-form-field-lite [control]="form.controls.guardianFirstName" i18n-label label="Guardian First Name">
        <input
          data-qa="applicantDetails_inputGuardianFirstName"
          formControlName="guardianFirstName"
          pInputText
          type="text"
          [attr.autocomplete]="'guardian-given-name'"
        />
      </lx-form-field-lite>
      <lx-form-field-lite [control]="form.controls.guardianLastName" i18n-label label="Guardian Last Name">
        <input
          data-qa="applicantDetails_inputGuardianLastName"
          formControlName="guardianLastName"
          pInputText
          type="text"
          [attr.autocomplete]="'guardian-family-name'"
        />
      </lx-form-field-lite>
    </div>

    <div class="applicant-details__full-name">
      <lx-form-field-lite [control]="form.controls.firstName" [label]="firstNameLabel">
        <input data-qa="applicantDetails_inputFirstName" formControlName="firstName" pInputText type="text" [attr.autocomplete]="'given-name'" />
      </lx-form-field-lite>
      <lx-form-field-lite [control]="form.controls.lastName" [label]="lastNameLabel">
        <input data-qa="applicantDetails_inputLastName" formControlName="lastName" pInputText type="text" [attr.autocomplete]="'family-name'" />
      </lx-form-field-lite>
    </div>

    <lx-form-field-lite [control]="form.controls.countryOfResidence" i18n-label label="Country of residence">
      <lx-residence-country-selector i18n-title title="Country of residence" formControlName="countryOfResidence"></lx-residence-country-selector>
    </lx-form-field-lite>

    <lx-form-field-lite *ngIf="regionLabel" [control]="form.controls.regionCode" [label]="regionLabel">
      <lx-region-country-field
        [title]="regionLabel"
        formControlName="regionCode"
        [regions]="regions"
        [textInputMode]="postalCodeRegion"
        [placeholder]="postalCodeRegion ? '' : regionPlaceholder"
      ></lx-region-country-field>
    </lx-form-field-lite>

    <lx-form-field-lite [control]="form.controls.email" i18n-label label="Email">
      <input data-qa="applicantDetails_inputEmail" formControlName="email" pInputText type="email" lxBlockSpaces [attr.autocomplete]="'email'" />
    </lx-form-field-lite>

    <lx-form-field-lite [control]="form.controls.phoneNumber" i18n-label label="Phone">
      <lx-phone-number-field i18n-title title="Phone code" formControlName="phoneNumber"></lx-phone-number-field>
    </lx-form-field-lite>

    <div *ngIf="whatsappOptIn" class="applicant-details__whatsapp-opt-in" (keydown.enter)="toggleCheckbox('whatsappOptIn')">
      <div class="applicant-details__whatsapp-opt-in__checkbox">
        <p-checkbox [binary]="true" data-qa="applicantDetails_whatsappOptIn" formControlName="whatsappOptIn"></p-checkbox>
      </div>
      <div class="applicant-details__whatsapp-opt-in__text" i18n>Are you happy for us to respond to your inquiry via WhatsApp?</div>
    </div>

    <div class="applicant-details__marketing-opt-out" (keydown.enter)="toggleCheckbox('optOutMarketing')">
      <div class="applicant-details__marketing-opt-out__checkbox">
        <p-checkbox [binary]="true" data-qa="applicantDetails_optOutMarketing" formControlName="optOutMarketing"></p-checkbox>
      </div>
      <div class="applicant-details__marketing-opt-out__text" i18n>
        We'd like to keep in touch to share the latest news and special offers from the
        <span
          (click)="togglePopup()"
          role="button"
          tabindex="0"
          (keydown)="onControlKeydown($event, 'toggle')"
          class="applicant-details__marketing-opt-out__link"
          [class.applicant-details__marketing-opt-out__link--juniors]="juniorFlow"
          aria-haspopup="dialog"
          [attr.aria-expanded]="popupDisplayed"
          aria-controls="kaplan-group-popup"
          >Kaplan Languages Group</span
        >
        . If this isn't for you, tick the box to opt out.
      </div>
    </div>

    <div
      *ngIf="popupDisplayed"
      @bubbleAnimation
      id="kaplan-group-popup"
      class="applicant-details__popup"
      role="dialog"
      aria-modal="false"
      aria-labelledby="kaplan-group-title"
      tabindex="-1"
      (keydown.escape)="closePopup()"
    >
      <i
        (click)="closePopup()"
        class="pi pi-times applicant-details__popup-close"
        tabindex="0"
        (keydown)="onControlKeydown($event, 'close')"
        role="button"
        aria-label="Close"
      ></i>
      <div id="kaplan-group-title" class="applicant-details__popup-title" i18n>Kaplan Group</div>
      <div class="applicant-details__popup-body" i18n>
        Kaplan International Languages, Kaplan International Pathways, Kaplan Open Learning, Alpadia Language Schools, ESL Language Group
      </div>
    </div>

    <div class="applicant-details__terms-text">
      <ng-container i18n>We work with authorized resellers to offer you advice and support.</ng-container>
      <ng-container i18n>
        To find out more about how we handle your personal data see our
        <a [href]="privacyPolicyLink" class="applicant-details__terms-link" data-qa="applicantDetails_privacyPolicyLink" target="_blank">Privacy Policy</a>
      </ng-container>
      .
      <ng-container i18n>By clicking submit, I am confirming I am over the age of 16.</ng-container>
    </div>
    <lx-acquisition-disclaimer></lx-acquisition-disclaimer>
    <div class="applicant-details__submit-button">
      <lx-button
        [class.applicant-details__submit-button--adult]="!juniorFlow"
        tabindex="0"
        [class.applicant-details__submit-button--junior]="juniorFlow"
        (buttonEnter)="onSubmit()"
        (buttonClick)="onSubmit()"
        [block]="true"
        [btnRounded]="true"
        [buttonStyle]="'primary'"
        data-qa="applicantDetails_sendMyQuoteBtn"
        i18n-text
        id="btn-next"
        text="Send my quote"
        [lxGAClickEvent]="emailRegisterGAEvent"
      >
      </lx-button>
    </div>
  </form>
</div>
